import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionComponent from './ActionComponent';
import HfrComponent from './HfrComponent';
import _ from 'lodash';
import DynamicSearchBar from './../../components/common/SearchBar';
import OverlayComponent from './OverlayComponent';
import SearchableDropdownComponent from '../../components/common/SearchableDropDown';
import DataTable from '../../components/common/CommonDataTable';
import OverlayCard from '../../components/common/OverlayCard';
import Button from './../../components/common/Button';
import PlusSvgIcon from './../../assets/svg_main/plus.svg';
import SettingIcon from './../../assets/svg_main/settings.svg';
import CrossIcon from '../../assets/svg_main/CrossIconBlack.svg';
import axios from '../../utils/axiosExt';
import endpoints from '../../config/endpoints';
import SucessModalComponent from '../../components/common/SuccessModal';
import DownloadModal from '@components/common/DownloadModal';
import DownArrow from '@assets/svg/download-01.svg';
import Auth from './../../utils/auth'
import { WithPermission } from './../../components/Auth/withPermission';
import { PagePermission } from './../../services/usePermission';
import InfoIcon from './../../assets/svg_main/info.svg'
import TooltipComponent from '@components/common/TooltipComponent';
import InfoSvgIcon from './../../assets/svg/generalInfo.svg';
import { errorLogger } from '@utils/applicationLogUtils';
import { decode, decodeWithKeyAndShift, encode } from '@utils/base64Utils';
import { additionalColumnsFormoduleGrid, facilityManagementColumnHeader } from '@constants/appConstants';
import { handleDynamicColumnForGird } from '@utils/commonUtils';
interface objectType {
  [key: string]: any;
}

let filterCheckBox: objectType = {};
let dropdowndata: objectType = {};

const style = {
  singleValue: (baseStyles: any) => ({
    ...baseStyles,
    fontSize: '12px',
    color: '#797979',
    textAlign: 'center',
    padding: '5px 10px',
  }),
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    fontSize: '12px',
    color: state.isFocussed ? '#FFF' : '#797979',
    '&:hover': {
      color: '#FFF',
    },
  }),
  menu: (style: any) => ({
    ...style,
    maxHeight: 250,
  }),
  menuList: (style: any) => ({
    ...style,
    maxHeight: 250,
    overFlowY: 'auto',
  }),
  placeholder: (base: any, state: any) => ({
    ...base,
    marginTop: 5,
    marginLeft: 5,
    color: 'rgba(179, 179, 179, 1)',
    fontWeight: 400,
    fontSize: 12,
    display: state.isFocused && 'none',
  }),
  multiValue: (base: any, state: any) => ({
    ...base,
    minWidth: '55px',
  }),
  valueContainer: () => ({
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'overlay',
    marginLeft: 5,
    fontSize: 12,
  }),
};

const constructActionData = (dataList: any) => {
  return dataList.map((data: any) => {
    return {
      ...data,
      hfr_id: {
        value: data.hfr_id,
        type: 'component',
        component: HfrComponent,
      },
      Action: {
        type: 'component',
        component: ActionComponent,
      },
    };
  }).reverse();
};

const FacilityManagement = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [gridData, setGridData] = useState<any[]>([]);
  const [eventKeyval, seteventKeyval] = useState<any[]>([]);
  const [checkboxValue, setCheckboxValue] = useState<any>({});
  const [dataExport, setDataExport] = useState<any[]>([]);
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [closeDownloadModal, setCloseDownloadModal] = useState<boolean>(false)
  const [dropDownFilterList, setDropDownFilterList] = useState<any>({});
  const handleSearchChange = _.debounce((value: string) => {
    setSearchTerm(value);
  }, 1000);
  const [showLoader, setShowLoader] = useState<boolean>(true);

  const navigate = useNavigate();

  const tempDataForFilter = useRef<any[]>([]);
  const [Columnheader, setColumnheader] = useState<any[]>(JSON.parse(JSON.stringify(facilityManagementColumnHeader)));

  const dropDownKeys = _.filter(
    Columnheader,
    (filterList) => filterList.filterRequired,
  );

  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));

  const handleDynamicColumn = (userType: any) => {
    const modifiedColumnHeaders: any[] = JSON.parse(JSON.stringify(handleDynamicColumnForGird(userType, JSON.parse(JSON.stringify(facilityManagementColumnHeader)), additionalColumnsFormoduleGrid.columnsBefor.admin_body, additionalColumnsFormoduleGrid.pages.health_facility)));
    setColumnheader(JSON.parse(JSON.stringify(modifiedColumnHeaders)));
  };

  useEffect(() => {
    if (decodedUserData && decodedUserData?.usertype_code) {
      handleDynamicColumn(decodedUserData?.usertype_code);
    } else {
      setColumnheader(JSON.parse(JSON.stringify(facilityManagementColumnHeader)));
    }
  }, []);

  const formatData = (res: any) => {

    setDataExport(res?.data?.data ?? res?.data);

    dropDownKeys.forEach((item, idx) => {
      const option = _.map(_.uniq(_.map(res?.data?.data ?? res?.data, item.key)), (i) => {
        if (i) {
          return { value: i, label: i };
        }
      });
      const options = option.filter((item: any) => item !== undefined);
      dropdowndata = {
        ...dropdowndata,
        [item.key]: options,
      };
      filterCheckBox = {
        ...filterCheckBox,
        [item.key]: idx < 3,
      };
    });
    let modifiedData: any[] = constructActionData(res?.data?.data ?? res?.data)
    modifiedData = modifiedData.map((ele: any) => {
      return {
        ...ele,
        urban_or_rural: ele.urban_or_rural ? `${ele.urban_or_rural.charAt(0).toUpperCase() + ele.urban_or_rural.slice(1)}` : ''
      }
    });
    tempDataForFilter.current = modifiedData;
    const filterlistfromSession = sessionStorage.getItem('facilityFilter');
    const parseToObject = filterlistfromSession ? JSON.parse(filterlistfromSession) : null;
    parseToObject ? setCheckboxValue({ ...parseToObject }) : setCheckboxValue({ ...filterCheckBox });
    setGridData(modifiedData.reverse());
    setShowLoader(false);
  }

  const initialFetch = () => {
    axios
      .get(endpoints.getAllFacility, Auth.loggedIn())
      .then((res: any) => {
        if (res) {
          formatData(res);
        }
      })
      .catch((error: any) => {
        errorLogger(error?.response?.data || error?.response || error)
      });
  }

  const filterFetch = () => {
    const encodedNumber = encodeURIComponent(encode(JSON.stringify(searchTerm)));
    axios
      .get(endpoints.getfilterFacility + '/' + encodedNumber, Auth.loggedIn())
      .then((res: any) => {
        const decodedResponse= JSON.parse(decode(res.data.data));
        formatData(decodedResponse);
      })
      .catch((error: any) => {
        errorLogger(error?.response?.data || error?.response || error)
      });
  }

  useEffect(() => {
    if (searchTerm.length === 0) {
      setShowLoader(true);
      initialFetch();
    }
    else if (searchTerm.length >= 3) {
      filterFetch();
    }
  }, [searchTerm])

  useEffect(() => {
    const list = getDropDownOptions(gridData);
    setDropDownFilterList({ ...list });
  }, [gridData]);

  const filterLoop = (dataList: any[], key: string, keyFilter: string[]) => {
    const tempData: any[] = [];
    dataList.forEach((dataValue: any) => {
      if (key === 'hfr_id') {
        if (keyFilter.find((val) => val === dataValue.hfr_id.value)) {
          tempData.push(dataValue);
        }
      }
      else {
        if (keyFilter.find((val) => val === dataValue[key])) {
          tempData.push(dataValue);
        }
      }
    });
    return tempData;
  };

  const applyFilter = (eventKey: any, index: number, eValue: any) => {
    const updatedValues = [...eventKeyval];
    updatedValues[index] = eventKey;
    seteventKeyval(updatedValues);
    let tempData: any = [...tempDataForFilter.current];
    // const keyNames = Object.keys(filterCheckBox);
    const keyNames = dropDownKeys.map((item) => item.key);
    updatedValues.forEach((keyFilter: any, i: number) => {
      const key = keyNames[i];
      if (keyFilter && keyFilter.length >= 1) {
        tempData = filterLoop(tempData, key, keyFilter);
      }
    });
    setGridData(tempData);
  };

  const clearFilter = () => {
    seteventKeyval([]);
    setGridData(tempDataForFilter.current);
  };

  const onChangeCheckbox = (list: any) => {
    setCheckboxValue({ ...list });
    sessionStorage.setItem("facilityFilter", JSON.stringify({ ...list }));
    setShow(false);
  };

  const getDropDownOptions = (data: any) => {
    let dropdowndataValue = {};
    dropDownKeys.forEach((item, idx) => {
      const itemMap = _.map(data, (itemKey) => {
        if (itemKey[item.key] && itemKey[item.key].type == 'component') {
          return itemKey[item.key].value
        } else {
          return itemKey[item.key]
        }
      });
      const uniquList = _.uniq(itemMap);
      const option = _.map(uniquList, (i) => {
        if (i) {
          if (i.type == 'component') {
            return { value: i.value, label: i.value };
          } else {
            return { value: i, label: i };
          }
        }
      });
      const options = option.filter((item: any) => item !== undefined);
      dropdowndataValue = {
        ...dropdowndataValue,
        [item.key]: options,
      };
    });
    return dropdowndataValue;
  }

  const renderFilter = () => {
    return dropDownKeys.map((dropdata, index) => {
      const selectedDropdownValue =
        eventKeyval[index] &&
        eventKeyval[index].map((key: string) => ({
          value: key,
          label: key,
        }));
      if (!checkboxValue[dropdata.key]) return;
      return (
        <>
          <SearchableDropdownComponent
            options={dropDownFilterList[dropdata.key]}
            placeHolder={dropdata.name}
            multipleSelection={true}
            onChange={(value) => applyFilter(value, index, dropdata.key)}
            dropDownType="entered"
            dropLabelName={dropdata.name}
            dropDownDisable={false}
            ifRequired={false}
            dropdownsearchable={true}
            isClearable={false}
            className={'user-filter-dropdown'}
            style={style}
            value={selectedDropdownValue ? selectedDropdownValue : null}
          />
        </>
      );
    });
  }

  const addUser = () => {
    navigate(`/health-facility/create`);
  };
  const closeModal = () => {
    setModal(false);
    initialFetch();
  };
  const finishModal = () => {
    setModal(false);
  }
  const closeSuccess = () => {
    setSuccessModal(false);
  }
  const excelData = dataExport.map((item, index) => ({
    serialNo: index + 1,
    ...item
  }));
  const dataToExportExcel = [
    {
      sheet: 'Sheet 1',
      columns: [
        { label: 'Sl.No.', value: 'serialNo' },
        { label: 'Facility Name', value: 'facility_name' },
        { label: 'HFR ID', value: 'hfr_id' },
        { label: 'Facility Type', value: 'facility_type' },
        { label: 'Status', value: 'stauts' },
        { label: 'Administrative Body', value: 'admin_body' },
      ],
      content: excelData,
    },
  ];

  const dataToExportPDF = {
    content: [
      { text: 'Health Facilities', style: 'header' },
      {
        table: {
          headerRows: 1,
          widths: Array(6).fill('auto'),
          body: [
            [
              { text: 'Sl.No.', style: 'tableHeader' },
              { text: 'Facility Name', style: 'tableHeader' },
              { text: 'HFR ID', style: 'tableHeader' },
              { text: 'Facility Type', style: 'tableHeader' },
              { text: 'Status', style: 'tableHeader' },
              { text: 'Administrative Body', style: 'tableHeader' },
            ],
            ...dataExport.map((item, index) => [
              index + 1,
              item.facility_name,
              item.hfr_id,
              item.facility_type,
              item.stauts,
              item.admin_body,
            ]),
          ],
        },
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
      },
      tableBody: {
        fontSize: 8,
      },
    },
    defaultStyle: {
      fontSize: 8,
    },
  };
  const downloadClick = () => {
    setCloseDownloadModal(true);
  }
  const onCloseDownloadModal = (value: boolean) => {
    if (value) {
      setCloseDownloadModal(false);
    }
    else {
      setCloseDownloadModal(false);
    }
  }
  const canCreateUser = PagePermission("FcltyMgmt", "FcltyMgmt_CrPg");

  const text = 'Only top 100 results displayed. Please use contextual input to narrow down the search result';

  return (
    <div className="user-management-details">
      {!showLoader ? <>
        <div className="search-add-user">
          <div className='search-bar-container' >
            <DynamicSearchBar
              onChange={handleSearchChange}
              placeHolder={'Search by Facility Name or Facility Type or Admin Body'}
              disabled={false}
              className="user-search"
              iconNeeded={true}
            />
            <div className="tooltip-custom"><InfoSvgIcon />
              <span className="tooltiptext">
                Search for exact words or phrases to narrow down the search results.
              </span>
            </div>

          </div>
          <div className='create-new-facility-btn-wrapper'>
            {canCreateUser && <Button
              onClick={addUser}
              disabled={false}
              id="add-user"
              buttonName="Create new facility"
              colorType="primary"
              icon={<PlusSvgIcon />}
              iconPosition="left"
            />}
            <TooltipComponent text={text}>
            <InfoIcon/>
            </TooltipComponent>
          </div>
        </div>
        <div className="user-filter">
          <div className="facility-filter-label-icon">
            <h6 className="user-filter-label">FILTERS</h6>
            <div className='download_symbol_css'>

          <DownArrow className='down_arrow_cursor' onClick={downloadClick}/>
              {closeDownloadModal && <DownloadModal closeModal={onCloseDownloadModal} showModal={closeDownloadModal} dataToExportExcel={dataToExportExcel}
                dataToExportPDF={dataToExportPDF}
          fileNameToExport={"healthFacilities"}/>}
              <OverlayCard
                show={show}
                setShow={setShow}
                triggerComponent={show ? <CrossIcon className="user-cross-icon" /> : <SettingIcon className="user-setting-icon" />}
                trigger="click"
                overlayComponent={<OverlayComponent dropDownKeys={dropDownKeys} onChange={onChangeCheckbox} checkboxValue={checkboxValue} />}
                placement="bottom-end"
              />
            </div>
          </div>
          <div className="filter">
          <div style={{display:'flex',flexWrap:'wrap'}} >
              {dropDownKeys && dropDownFilterList && renderFilter()}
              {/* {Object.values(checkboxValue).includes(true) && */}
              {eventKeyval?.some((filter) => filter?.length > 0) &&
                (
                  <Button
                    onClick={clearFilter}
                    disabled={false}
                    id="user-filter-clear"
                    buttonName={'Clear Filter'}
                    colorType={'save'}
                    icon={''}
                    iconPosition={''}
                  />
                )}
            </div>
            <p id='filter-message' >Showing top 100 records</p>
          </div>
        </div>
        <div className="user-table">
          <WithPermission moduleCode="FcltyMgmt" pageCode='FcltyMgmt_LstPg' privilege="view">
            <DataTable
              data={gridData}
              itemsPerPage={[10, 20, 30, 40, 50]}
              height={'300px'}
              searchTerm={searchTerm}
              columnHeader={Columnheader}
              gridFor={'healthFacility'}
            />
          </WithPermission>
        </div>
        {successModal && (
          <div className='success_warning_component'>
            <SucessModalComponent successHeader={'Health Facility Upgrade Request Initiated'} closeSuccessModal={closeSuccess} typeModal={'success'} successButtonName={'View Details'} />
            <SucessModalComponent successHeader={'Health Facility Upgrade Approval Pending'} closeSuccessModal={closeSuccess} typeModal={'warning'} successButtonName={'View Details'} />
          </div>
        )}
      </> : <div className='loader'>Loading...</div>}
    </div>
  );
};

export default FacilityManagement;
